import { ProductionComponentInstanceStatus } from '@paragon/contract-library';

export const statusColors: { [K in ProductionComponentInstanceStatus]: string } = {
  Unscheduled: 'blanchedalmond',
  Scheduled: 'lightsalmon',
  StartedAssembly: 'orangered',
  FinishedAssembly: 'lightgreen',
  StoredOnYard: 'violet',
  Shipped: 'tan',
  Delivered: 'mediumblue',
};
